// removed by extract-text-webpack-plugin
module.exports = {"purple":"#9800ff","small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wrapper":"profile__wrapper___144Jk","content":"profile__content___13EE3 layout__content___2G64l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/profile.css
// module id = 163
// module chunks = 0